jQuery(document).ready(function($) {
	
	$.tabs = {

		init: function() {

			$(document).on('click', '.m-start-media__tab', function(e) {
                e.preventDefault();
                
                var mediatype = $(this).data('mediatype');

                $('.m-start-media__tab.active').removeClass('active');
                
                $(this).addClass('active');

                $('.js-mediatype-content').hide();

                $('#js-mediatype-'+mediatype).show();
			});

		},
	
	};

});
